import styles from "./Button.module.css"; 

function Button({
  children,
  onClick,
  onChange,
  type = "button",
  disabled = false,
  className = "",
  iconLeft = null,
  iconRight = null,
  selectLabel = "",
  options = [],
  name = "",
  loading = false,
  variant = "",
  selectVariant="",
  ...rest
}) {
  const validVariants = ["secondary", "outline", "dark"];
  const safeVariant = validVariants.includes(variant) ? variant : "dark";
  const combinedClassName =
    `${styles.button} ${styles[safeVariant]} ${className}`.trim();

  const parsedOptions = Array.isArray(options)
    ? options
    : typeof options === "string"
    ? options.split(",").map((opt) => opt.trim())
    : [];

  if (type === "select") {
    return (
      <div className={styles.selectWrapper}>
        <select
          name={name}
          disabled={disabled || loading}
          className={`${styles.button} ${styles[safeVariant] || styles.dark} ${
            styles.selectWithIcon
          } ${className}`.trim()}
          onChange={onChange || onClick}
          defaultValue=""
          {...rest}
        >
          <option value="">{selectLabel || "Select an option"}</option>
          {parsedOptions.map((option, index) => {
            const isObject = typeof option === "object" && option !== null;
            const label = isObject
              ? option.label || option.name || option.platform || `Option ${index + 1}`
              : option;
            const value = isObject
              ? option.value || option.id || option.name || option.platform
              : option;

            return (
              <option key={index} value={value}>
                {label}
              </option>
            );
          })}
        </select>
        {iconRight && !loading && (
          <span className={styles.iconRightSelect}>{iconRight}</span>
        )}
        {loading && <span className={styles.loader}></span>}
      </div>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={`${combinedClassName} ${loading ? styles.loading : ""}`}
      {...rest}
    >
      {iconLeft && !loading && (
        <span className={styles.iconLeft}>{iconLeft}</span>
      )}
      {loading ? (
        <span className={styles.loader}></span>
      ) : (
        <span>{children}</span>
      )}
      {iconRight && !loading && (
        <span className={styles.iconRight}>{iconRight}</span>
      )}
    </button>
  );
}

export default Button;
